module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {}, [_c('div', {}, [_c('div', {}, [_c('div', {
    attrs: {
      "id": "details"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-column"
  }), _vm._v(" "), _c('gmap-map', {
    staticStyle: {
      "width": "100%",
      "height": "75vh"
    },
    attrs: {
      "center": _vm.center,
      "zoom": 18,
      "map-type-id": "terrain"
    }
  }, [_c('gmap-marker', {
    attrs: {
      "position": _vm.currentLocation,
      "icon": _vm.getMarkerIcon(_vm.currentLocation)
    },
    on: {
      "click": _vm.openInfoWindow
    }
  }, [_c('gmap-info-window', {
    attrs: {
      "options": _vm.infoWindowOptions,
      "position": _vm.currentLocation,
      "opened": _vm.infoWindowOpen
    },
    on: {
      "closeclick": _vm.closeInfoWindow
    }
  }, [_c('div', [_vm._v("\n                                    Zone:"), _c('strong', [_vm._v(_vm._s(_vm.detailsOnZone.zoneName) + " ")]), _c('br'), _vm._v("\n                                    Driver Name:"), _c('strong', [_vm._v(_vm._s(_vm.detailsOnZone.driverFirstName + ' ' +
    _vm.detailsOnZone.driverLastName))]), _vm._v(" "), _c('br'), _vm._v("\n                                    Vehicle Number:"), _c('strong', [_vm._v(_vm._s(_vm.vehicleNumber))]), _vm._v(" "), _c('br')])])], 1), _vm._v(" "), _c('gmap-marker', {
    attrs: {
      "position": _vm.startIcon,
      "icon": _vm.getStartMarkerIcon()
    }
  }), _vm._v(" "), _c('gmap-marker', {
    attrs: {
      "position": _vm.endIcon,
      "icon": _vm.getEndMarkerIcon()
    }
  }), _vm._v(" "), _vm._l((_vm.data), function(polyline, index) {
    return _c('gmap-polyline', {
      key: index,
      attrs: {
        "path": polyline.coordinates,
        "options": _vm.getPolylineOptions(polyline.status)
      }
    })
  })], 2)], 1)])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-50f9a06b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50f9a06b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/gmapLocation/traccarMonitoringGMap.vue
// module id = 2318
// module chunks = 0